import React from 'react';
import PropTypes from 'prop-types';
const reject = require('lodash/reject');
const filter = require('lodash/filter');
const find = require('lodash/find');

const Globals = require('../../../../app/globals');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
import ChannelProjectFolderTree from './Tree/ChannelProjectFolderTree';

const propTypes = {
    selectedProject: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onSelect: PropTypes.func.isRequired,
    label: PropTypes.string,
    excludeProject: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    permissionsFunc: PropTypes.func, // function for filtering permissions. should expect params: func(userChannelPermissions, userProjectPermissions)
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]),
    restrictToChannelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // restrict to single channel ID
};

const defaultProps = {
    label: '',
    excludeProject: null,
    permissionsFunc: null,
    contentType: Globals.content_type.ACTIVITY,
    restrictToChannelId: "",
};

class ProjectSelector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            channelStoreState: ChannelStore.getState(),
            projectStoreState: ProjectStore.getState()
        };
        this.unsubscribes = [
            ChannelStore.listen(this.onStoreChange.bind(this, "channelStoreState")),
            ProjectStore.listen(this.onStoreChange.bind(this, "projectStoreState"))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state })
    }

    render() {
        if (
            !this.state.channelStoreState.initialized
            || !this.state.projectStoreState.initialized
        ) {
            return null;
        }

        let allProjects = [];
        let filteredProjects;
        let folders = {};
        let foldersFlat = {};
        let filteredChannels = this.state.channelStoreState.channelsAndOrgs;
        if (this.props.contentType === Globals.content_type.ACTIVITY) {
            folders = this.state.channelStoreState.folders;
            foldersFlat = this.state.channelStoreState.foldersFlat;
            allProjects = this.state.projectStoreState.projects;
        }
        else if (this.props.contentType === Globals.content_type.COURSE) {
            folders = this.state.channelStoreState.shortCourseFolders;
            foldersFlat = this.state.channelStoreState.shortCourseFoldersFlat;
            allProjects = this.state.projectStoreState.shortCourseProjects;
        }

        filteredProjects = allProjects;

        const parsedRestirctToChannelId = parseInt(this.props.restrictToChannelId, 10);
        if (!isNaN(parsedRestirctToChannelId)) {
            filteredChannels = filter(filteredChannels, { id: parsedRestirctToChannelId });
            filteredProjects = filter(filteredProjects, { channelId: parsedRestirctToChannelId });
            // TODO: filter folders & foldersFlat?
        }

        if (!!this.props.permissionsFunc) {
            filteredProjects = filter(filteredProjects, (proj) => {
                const projChannel = find(filteredChannels, { id: proj.channelId });
                if (!projChannel) {
                    console.warn(`ProjectSelector: Channel not found for project ${proj.id}`);
                    return false;
                }

                return this.props.permissionsFunc(projChannel.user_permissions, proj.user_permissions);
            });
        }

        const parsedExdludeProject = parseInt(this.props.excludeProject, 10);
        if (!isNaN(parsedExdludeProject)) {
            filteredProjects = reject(filteredProjects, { id: parsedExdludeProject });
        }

        return (
            <div>
                <label className="body-text" htmlFor="project-select">{this.props.label}</label>
                <br/>
                {/* !!this.props.selectedProject ?
                    <dl className="inline-list-elems">
                        <dt>Selected Project</dt>
                        <dd>
                            {find(_projects, {id: this.props.selectedProject}).name}
                        </dd>
                    </dl>
                    :
                    <div className="margin-bottom-lg">
                        Please select a project:
                    </div>
                */}
                <ChannelProjectFolderTree
                    id="project-select"
                    className="margin-top-md"
                    channels={filteredChannels}
                    folders={folders}
                    foldersFlat={foldersFlat}
                    projects={filteredProjects}
                    selectedProjectId={parseInt(this.props.selectedProject, 10)}
                    onSelect={this.props.onSelect}
                />
            </div>
        );
    }
}

ProjectSelector.propTypes = propTypes;
ProjectSelector.defaultProps = defaultProps;

export default ProjectSelector;